import axios from 'axios';

const API_URL = (import.meta as any).env.VITE_API_URL || 'http://localhost:5001';

export const payloadApi = axios.create({
    baseURL: `${API_URL}/api`,
    withCredentials: true, // Important for session cookies if we rely on that
    headers: {
        'Content-Type': 'application/json',
    },
});

export const FeedbackService = {
    createTicket: async (ticketData: any) => {
        const response = await payloadApi.post('/tickets', ticketData);
        return response.data;
    },

    getTestPlans: async () => {
        // Fetch active test plans
        const response = await payloadApi.get('/test-plans?where[status][equals]=active');
        return response.data;
    },

    getMyTickets: async (userId: string) => {
        const response = await payloadApi.get(`/tickets?where[reportedBy][equals]=${userId}`);
        return response.data;
    }
};
